<div class="layout-footer">
  <img
    src="assets/layout/images/{{ layoutService.config().colorScheme === 'light' ? 'logo-black' : 'logo-white' }}.svg"
    alt="Logo"
    height="20"
    class="mr-2" />by
  <a href="https://www.corvallis.it"><span class="font-medium ml-2">Corvallis S.R.L.</span> </a>
</div>
